import { render, staticRenderFns } from "./ProductMainView.vue?vue&type=template&id=594670fd&"
import script from "./ProductMainView.vue?vue&type=script&lang=js&"
export * from "./ProductMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports